export default "__VITE_ASSET__BEDunhqv__"